import Text from '@ingka/text';

import type { PriceSummaryEntry } from './price-summary-overview.types';

import styles from '../../styles.module.scss';

type PriceSummaryOverviewEntryProps = PriceSummaryEntry;

export const PriceSummaryOverviewEntry = (props: PriceSummaryOverviewEntryProps) => {
    if (!props.shouldRender) {
        return null;
    }

    const textStyle = props.emphasized ? 'Heading.S' : 'LabelRegular.M';

    const classNames = [styles.asset_price_summary_list_item]
        .concat(props.emphasized ? [styles.asset_price_summary_list_item_emphasized] : [])
        .join(' ');

    return (
        <li className={classNames}>
            <Text colour={false} textStyle={textStyle}>
                {props.description}
            </Text>
            <Text colour={false} textStyle={textStyle}>
                {props.reducesPrice ? '- ' : ''}
                {props.value}
            </Text>
        </li>
    );
};
